import styled from "styled-components";

import Modal from "../../../components/Modal";
import { Button } from "../styles/auth";
import { INVALID_LOGIN_MESSAGE } from "./loginErrors";

const Box = styled.div`
  background-color: var(--white, #ffffff);
  border-radius: 8px;
  padding: 2.5rem 2rem 2rem;
  width: 90%;
  max-width: 30rem;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);
`;

const Title = styled.h2`
  margin: 0 0 1rem;
  font-size: 1.5rem;
`;

const Message = styled.p`
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
  line-height: 1.5;
`;

interface Props {
  open: boolean;
  close: () => void;
}

const InvalidCredentialsModal = ({ open, close }: Props) => (
  <Modal open={open} close={close}>
    <Box
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="login-error-title"
    >
      <Title id="login-error-title">Unable to sign in</Title>
      <Message>{INVALID_LOGIN_MESSAGE}</Message>
      <Button type="button" onClick={close} autoFocus>
        OK
      </Button>
    </Box>
  </Modal>
);

export default InvalidCredentialsModal;
